import { useState } from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Link,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useAccount } from '../../contexts/Account';
import { resignFromBoard } from '../../services/advisor_services';
import { useHistory, useLocation } from 'react-router-dom';
import {
  deleteBoardRoomAppleCalendar,
  deleteBoardRoomGoogleCalendar,
} from '../../services/company_services';

const useStyles = () => ({
  dialogContainer: {
    padding: '15px',
  },
  dialogActions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-evenly',
    flexDirection: 'row',
  },
});

const LeaveBoardButton = (props) => {
  let { company } = props;

  const { accountDetails, editAccountInformation, asLoggedUserDetails } =
    useAccount();
  const isSM = useMediaQuery((theme) => theme.breakpoints.down([1230]));
  const classes = useStyles();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const calendarTokens = accountDetails?.calendarTokens || {};
  const googleToken = calendarTokens.google?.isSync;
  const appleToken = calendarTokens.apple?.isSync;

  function resignAction() {
    setIsModalLoading(true);
    resignFromBoard({
      ADVISOR_ID: asLoggedUserDetails.userId,
      COMPANY_ID: company.id,
    })
      .then(async () => {
        if (
          accountDetails.viewedBoards &&
          accountDetails.viewedBoards.length > 0
        ) {
          accountDetails.viewedBoards = accountDetails.viewedBoards.filter(
            (board) => board != company.id
          );
        }
        const newMemberBoards = [
          ...asLoggedUserDetails.advisorRelatedCompanies.memberBoards.filter(
            (element) => element.slug !== company.slug
          ),
        ];
        const nonRefMemberBoards = newMemberBoards.map((el) => ({ ...el }));
        accountDetails.boards.memberBoards = nonRefMemberBoards;
        asLoggedUserDetails.advisorRelatedCompanies.memberBoards =
          nonRefMemberBoards;

        editAccountInformation({
          boards: accountDetails.boards,
        });
        try {
          if (googleToken) {
            console.log(`Unsyncing Google Calendar for post`);
            await deleteBoardRoomGoogleCalendar({
              companyId: company.id,
              advisorId: accountDetails.id,
              token: calendarTokens.google.token,
            });
          }

          if (appleToken) {
            console.log(`Unsyncing Apple Calendar for post`);
            await deleteBoardRoomAppleCalendar({
              companyId: company.id,
              advisorId: accountDetails.id,
              email: calendarTokens.apple.email,
              password: calendarTokens.apple.password,
            });
          }
        } catch (error) {
          console.error(`Error syncing calendars for post:`, error.message);
        }

        if (location.pathname === '/dashboard') {
          window.location.reload();
        } else {
          history.push({
            pathname: '/dashboard',
            state: {
              resignedCompany: company.displayName,
            },
          });
        }

        setIsModalLoading(false);
        setIsModalVisible(false);
        // handleClickAway();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function LeaveBoardDialog() {
    return (
      <Dialog
        open={isModalVisible}
        sx={classes.dialogContainer}
        maxWidth="sm"
        onClose={() => {
          if (!isModalLoading) {
            setIsModalVisible(false);
          }
        }}
      >
        <div style={classes.dialogContainer}>
          <DialogContent>
            <DialogContentText>
              <Typography variant="caption" style={{ fontSize: 16 }}>
                Are you sure you want to leave this board?
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={classes.dialogActions}>
            {isModalLoading ? (
              <div style={classes.modalLoadingContainer}>
                <CircularProgress />
              </div>
            ) : (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setIsModalVisible(false);
                  }}
                  style={{
                    paddingTop: 15,
                    paddingBottom: 15,
                    height: 37,
                    borderRadius: 20,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => resignAction()}
                  style={{
                    paddingTop: 15,
                    paddingBottom: 15,
                    margin: 0,
                    height: 37,
                    borderRadius: 20,
                  }}
                >
                  Leave Board
                </Button>
              </>
            )}
          </DialogActions>
        </div>
      </Dialog>
    );
  }

  return (
    <>
      <Link
        onClick={() => setIsModalVisible(true)}
        sx={{
          fontWeight: '500',
          fontSize: '14px',
          lineHeight: '22px',
          color: '#2C71F6',
          textDecoration: 'none',
          cursor: 'pointer',
          mb: '4px',
        }}
      >
        Leave This Board
      </Link>
      {LeaveBoardDialog()}
    </>
  );
};

export default LeaveBoardButton;
